import { Injectable } from '@angular/core';

export interface SubMenu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
}
export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
  children: SubMenu[];
}

const MENUITEMS = [
  { state: 'dashboard', name: 'dashboard', type: 'link', icon: 'dashboard', priv: 'rd_dashboard', children: [] },
  { state: 'agence', type: 'link', name: 'gestionAgence', icon: 'domain_add' , priv: 'rd_agence', children: []},
  { state: 'account', type: 'link', name: 'gestionUtilisateur', icon: 'manage_accounts' , priv: 'rd_account', children: []},
  { state: 'role', type: 'link', name: 'gestionrole', icon: 'shield' , priv: 'rd_role', children: []},
  { state: 'bus', type: 'link', name: 'bus', icon: 'car_repair' , priv: 'rd_bus', children: []},
  { state: 'client', type: 'link', name: 'client', icon: 'groups' , priv: 'rd_setting', children: []},
  { state: 'chauffeur', type: 'link', name: 'chauffeur', icon: 'man' , priv: 'rd_chauffeur', children: []},
  { state: 'category', type: 'link', name: 'categoryList', icon: 'category' , priv: 'cr_colis', children: []},
  { state: 'typevoyage', type: 'link', name: 'typevoyageList', icon: 'airport_shuttle' , priv: 'cr_colis', children: []},
  { state: 'tarif', type: 'link', name: 'form_fields.tarif' , icon: 'attach_money' , priv: 'cr_colis', children: []},
  { state: 'free', type: 'link', name: 'freecode', icon: 'shuffle' , priv: 'rd_freeticket', children: []},
  { state: 'passengertravel', type: 'link', name: 'loyalty', icon: 'library_add' , priv: 'rd_loyalty', children: []},
  { state: 'logs', type: 'link', name: 'colislogs', icon: 'psychology' , priv: 'rd_colislogs', children: []},
  { state: 'session', type: 'link', name: 'raportsession', icon: 'update' , priv: 'rd_session', children: []},
  { state: 'session\/usersession', type: 'link', name: 'raportsessions', icon: 'insights' , priv: 'cr_colis', children: []},
  { state: 'fiscalite', type: 'link', name: 'fiscalite', icon: 'warning' , priv: 'rd_fiscalite', children: []},
  { state: 'setting', type: 'link', name: 'settings', icon: 'settings' , priv: 'rd_setting', children: []}
];

@Injectable()
export class MenuItems {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
